export enum DatasetType {
    AnalysisTcoh = 'analysisTcoh',
    AssetNeededOrUploadingTcoh = 'assetNeededOrUploadingTcoh',
    GraderTcoh = 'graderTcoh',
    RoundOneConsults = 'roundOneConsults',
    RoundTwoConsults = 'roundTwoConsults',
}
